var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mall-box"},[_c('img',{attrs:{"src":require("@/assets/img/images/news-nodata.png"),"alt":"news-nodata.png"}}),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t("news.noDataTips"))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }